import { Image, Page, StyleSheet, View } from "@react-pdf/renderer";
import React from "react";
import _ from "lodash";
import { getPresignedUrl } from "../../upload/utils";
import { getFooter } from "../../../utils/helperUtils";

const styles = StyleSheet.create({
    page: {
        padding: "40px 50px",
        backgroundColor: "#ffffff",
        position: "relative",
    },
    mainContainer: {
        flex: 1,
        paddingBottom: 50,
    },
    imageContainer: {
        width: "100%",
        height: "75vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        border: "1px solid #e0e0e0",
        borderRadius: 4,
        backgroundColor: "#f8f9fa",
        padding: "10px",
        marginBottom: "20px",
    },
    image: {
        maxWidth: "100%",
        maxHeight: "100%",
        objectFit: "contain",
    },
});

interface CompData {
    enable?: boolean;
    pdfPageS3Keys?: string[];
}

interface SpaceData {
    enable?: boolean;
    comps?: {
        [key: string]: CompData;
    };
}

interface IncomeCompsImagesPageProps {
    data: any;
    confidentialInfo: string;
}

const getEnabledCompImages = (data: any): string[] => {
    const spaces: { [key: string]: SpaceData } = _.get(
        data,
        "appealApproachCalculationData.income.spaces",
        {}
    );

    return Object.keys(spaces)
        .map(key => spaces[key])
        .filter(space => space.enable === true)
        .flatMap(space => {
            const comps = space.comps || {};

            return Object.keys(comps)
                .map(key => comps[key])
                .filter(comp => comp.enable === true)
                .flatMap(comp => comp.pdfPageS3Keys || []);
        });
};

const ImagePage: React.FC<{ imageS3Key: string; confidentialInfo: string }> = ({
    imageS3Key,
    confidentialInfo,
}) => (
    <Page size="A4" style={styles.page}>
        <View style={styles.mainContainer}>
            <View style={styles.imageContainer}>
                <Image source={getPresignedUrl(imageS3Key)} style={styles.image} />
            </View>
        </View>

        {getFooter(confidentialInfo)}
    </Page>
);

export const IncomeCompsImagesPage: React.FC<IncomeCompsImagesPageProps> = ({
    data,
    confidentialInfo,
}) => {
    const imageS3Keys = getEnabledCompImages(data);

    return (
        <>
            {imageS3Keys.map((imageS3Key, index) => (
                <ImagePage
                    key={`comp-image-${index}`}
                    imageS3Key={imageS3Key}
                    confidentialInfo={confidentialInfo}
                />
            ))}
        </>
    );
};
